import React from 'react'

const Dashboard10 = () => {
  return (
    <h1>Dashboard10</h1>
  )
}

export default Dashboard10